import z from 'zod';
import { objectIdRef } from '../common.js';
import { DateTimeSchema } from '../dates.js';
import {
  AnyCandidateProfile,
  CandidateProfilePromptType,
  CandidateProfileSchemaName,
} from '../llmResponseSchemas.js';

// TODO(#2203): move into the shared profile module phase 2 creates
export const NO_DEPARTMENT_KEY = 'NONE';

export const ICandidateProfileData = z.object({
  profile: AnyCandidateProfile,
  sources: objectIdRef('LlmResponse').array().describe('Contributing LlmResponse docs'),
  profileOutputHash: z.string().describe('hashObject(profile) — upsert idempotency'),
  promptType: CandidateProfilePromptType,
  schemaName: CandidateProfileSchemaName.nullish(),
  profileCreatedAt: DateTimeSchema.describe('When the source profile response was generated'),
  profileDepartmentKey: z
    .string()
    .array()
    .default([NO_DEPARTMENT_KEY])
    .describe('Department key with a default placeholder value to be indexible'),
});
export type ICandidateProfileData = z.infer<typeof ICandidateProfileData>;
